<template>
  <div class="side">
    <!-- 中部内容块 -->
    <div class="middle-section">
      <div style="height: 60vh">
        <div class="table-header">
          <div class="server-count">检测检查</div>
        </div>
        <div class="num-group">
          <div class="num-item">
            <img
              src="@/assets/imgs/icon-check.png"
              class="legend-icon"
              style="width: 20px; height: 20px"
            />
            <div class="num-box" @click="toInfo('check')">
              <span class="num-count">{{ checkTotalNum }}</span>
              <span class="num-title">检测数</span>
            </div>
          </div>
          <div class="num-item" style="display: flex; width: 50%">
            <img
              src="@/assets/imgs/icon-inspect.png"
              class="legend-icon"
              style="width: 20px; height: 20px"
            />
            <div class="num-box" @click="toInfo('inspect')">
              <span class="num-count">{{ inspectTotalNum }}</span>
              <span class="num-title">检查数</span>
            </div>
          </div>
        </div>
        <div class="chart_part">
          <div class="chart">
            <MultiLineChart
              :xAxisLabels="timeLabels"
              :seriesData="chartSeries"
            />
          </div>
        </div>
        <div class="chart_part">
          <div class="chart">
            <MultiLineChart
              :xAxisLabels="timeInspLabels"
              :seriesData="chartInspSeries"
            />
          </div>
        </div>
      </div>

      <div style="height: 40vh">
        <div class="table-header" @click="toInfo('jgj')">
          <div>智能终端</div>
          <!-- <div class="toInfo">筛选</div> -->
        </div>

        <div class="num-group" @click="toInfo('jgj')">
          <div class="num-item">
            <img
              src="@/assets/imgs/icon-check.png"
              class="legend-icon"
              style="width: 20px; height: 20px"
            />
            <div class="num-box">
              <span class="num-count">{{ ieTotalNum }}</span>
              <span class="num-title">终端数</span>
            </div>
          </div>
          <div class="num-item" style="display: flex; width: 50%">
            <img
              src="@/assets/imgs/icon-inspect.png"
              class="legend-icon"
              style="width: 20px; height: 20px"
            />
            <div class="num-box">
              <span class="num-count">{{ onlineNum }}</span>
              <span class="num-title">在线数</span>
            </div>
          </div>
        </div>
        <div class="chart_part">
          <div class="chart">
            <MultiLineChart
              :xAxisLabels="iescoreLabels"
              :seriesData="iescoreSeries"
            />
          </div>
        </div>
        <!-- <div class="chart_part"> -->
        <!-- <div class="flex" style="margin-bottom: 3vh"> -->
        <!-- <div class="chart">
            <ChartsColumn :ytitle="'分'" :data="workerRatingData" />
          </div> -->
        <!-- </div> -->
        <!-- </div> -->
      </div>
    </div>

    <!-- 弹框组件 -->
    <div class="modal-overlay" v-if="clockOpen">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">打卡记录</div>
        </div>
        <div class="modal-pro">项目:{{ clockProName }}</div>
        <div class="modal-body">
          <el-table :data="clockList" max-height="200" v-loading="loading">
            <el-table-column label="驾驶员" align="center" prop="driverName" />
            <el-table-column label="打卡类型" align="center" prop="onFlag">
              <template slot-scope="scope">
                {{ getOptionsType(scope.row.onFlag, clockTypeOptions) }}
              </template>
            </el-table-column>
            <el-table-column label="时间" align="center" prop="time" />
            <el-table-column label="打卡照片" align="center" prop="photo">
              <template slot-scope="scope">
                <image-preview
                  :src="fileShowUrl + scope.row.photo"
                  :width="50"
                  :height="50"
                />
              </template>
            </el-table-column>
          </el-table>
          <!-- <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getClockList"
          /> -->
        </div>

        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click="clockClose">关 闭</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { listScore } from '@/api/iemanage/scoreStatistics'
// import { getProject } from '@/api/manage/project'
import { getDeviceTotalCount, getNumberAndScoreMonth } from '@/api/detection'
import { getInpectDeviceCount, queryDeviceAndScoreByMonth } from '@/api/inspect'
import axios from 'axios'
export default {
  name: 'LeftPanel',

  components: {
    MultiLineChart: () => import('../charts_drivers/MultiLineChart.vue')
  },
  props: {
    beginTime: {
      type: String,
      required: true
    },
    endTime: {
      type: String,
      required: true
    },
    // 是否全屏
    isFullscreen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      fileShowUrl: process.env.VUE_APP_BASE_API + '/file',
      // jgjAPi: 'http://192.168.16.25:38080/',
      jgjAPi: 'https://dm.jsjxtzjc.com/prod-api/',
      clockProName: null,
      clockProId: null,
      projectId: null,
      dataInterval: null,
      paused: false,
      requestStatus: false,
      pausedBeh: false,
      clockOpen: false,
      loading: false,
      clockList: [],
      checkTotalNum: 0,
      inspectTotalNum: 0,
      ieTotalNum: 0,
      onlineNum: 0,
      total: 0,

      timeLabels: [],
      chartSeries: [],
      chartInspSeries: [],
      timeInspLabels: [],
      iescoreSeries: [],
      iescoreLabels: [],
      behaviorList: [],
      clockTypeOptions: [
        {
          dictValue: 1,
          dictLabel: '上班打卡'
        },
        {
          dictValue: 2,
          dictLabel: '下班打卡'
        }
      ],
      worktimeoutList: [],
      pickerDate: [],
      workPickerDate: [],
      queryParams: {
        pageNum: 1,
        pageSize: 20
      },
      queryClockParams: {
        pageSize: -1
      },
      queryWorkParams: {
        pageNum: 1,
        pageSize: 20
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      }
    }
  },

  async mounted() {
    await this.defaultTime()
    this.getDeviceTotalCountFn()
    this.getInpectDeviceCountFn()
    this.getNumberMonthFn()
    this.getInspectNumberMonthFn()
    this.getIeScore()
    this.getIeNumber()
    // console.log(this.isFullscreen)
    // // 轮询
    // this.getClockExceptionFn()
    // this.getWorktimeoutFn()
    // this.$nextTick(() => {
    //   if (this.beginTime && this.endTime) {
    //     this.projectRating()
    //     this.workerRating()
    //   }
    // })
  },
  beforeDestroy() {
    // clearInterval(this.dataInterval)
  },
  methods: {
    // 获取设备检测总台数
    getDeviceTotalCountFn() {
      getDeviceTotalCount({}).then((res) => {
        if (res.data) {
          this.checkTotalNum = res.data.otherCount
          // this.basketTotalCount = res.data.basketCount
          // this.otherTotalCount = res.data.otherCount
        }
      })
    },
    //设备总数
    getInpectDeviceCountFn() {
      getInpectDeviceCount({}).then((res) => {
        console.log(res, '总数')
        if (res.data) {
          this.inspectTotalNum = Number(res.data.count)
        }
      })
    },
    // 检测查看月度设备数量
    getNumberMonthFn() {
      let that = this
      // 默认当前月之前12个月
      // console.log('12个月')

      let getNumberMonthData = {
        startDt: that.pickerDate[0] || that.pickerDay[0],
        endDt: that.pickerDate[1] || that.pickerDay[1],
        // timeType: that.timeType, //1:年，2：月
        isBasket: '2' //是否包含吊篮
      }
      getNumberAndScoreMonth(getNumberMonthData).then((response) => {
        if (response.data && response.data.length > 0) {
          let arr = response.data
          that.timeLabels = arr.map((item) => {
            const time = item.month // 取空格后面的时分秒部分
            return time
          })

          let chartSeries = [
            {
              name: '检测月度设备数',
              type: 'line',
              data: arr.map((item) => item.totalCount)
            }
          ]
          that.chartSeries = chartSeries
        }
      })
    },
    // 默认时间
    defaultTime() {
      if (this.pickerDate.length == 0) {
        // 默认当前日期之前365天
        let sdate = new Date()
        let interval = -365 //间隔天数
        let caret = '-' //日期分隔符
        let strYear = sdate.getFullYear()
        let strDay = sdate.getDate()
        let strMonth = sdate.getMonth() + 1
        let patt1 = /^\d{4}-([0-1]?[0-9])-([0-3]?[0-9])$/ //判断输入的日期是否符合格式正则表达式
        if (!(sdate && typeof sdate == 'string' && patt1.test(sdate))) {
          sdate = new Date() //不满足日期的则使用当前年月日
        }
        interval = isNaN(parseInt(interval)) ? 0 : parseInt(interval) //若没有输入间隔，则使用当前日
        caret = caret && typeof caret == 'string' ? caret : ''
        let gdate = new Date(sdate).getTime() //获取指定年月日
        gdate = gdate + 1000 * 60 * 60 * 24 * interval //加减相差毫秒数
        let speDate = new Date(gdate) //获取指定好毫秒数时间
        let preYear = speDate.getFullYear()
        let preMonth = speDate.getMonth() + 1
        let preDay = speDate.getDate()
        preMonth = preMonth < 10 ? '0' + preMonth : preMonth
        preDay = preDay < 10 ? '0' + preDay : preDay
        let preDate = preYear + caret + preMonth + caret + preDay
        this.pickerDate = [preDate, strYear + '-' + strMonth + '-' + strDay]
      }
    },
    // 检查查看月度设备数量
    getInspectNumberMonthFn() {
      let that = this

      let obj = {
        startDt: that.pickerDate[0] || that.pickerDay[0],
        endDt: that.pickerDate[1] || that.pickerDay[1]
      }
      queryDeviceAndScoreByMonth(obj).then((response) => {
        if (response.data && response.data.length > 0) {
          let arr = response.data
          that.timeInspLabels = arr.map((item) => {
            const time = item.month // 取空格后面的时分秒部分
            return time
          })

          let chartSeries = [
            {
              name: '检查月度设备数',
              type: 'line',
              data: arr.map((item) => item.totalCount)
            }
          ]
          that.chartInspSeries = chartSeries
        }
      })
    },
    // ✅ 智能终端 在线离线数量
    async getIeNumber() {
      let that = this

      try {
        const res = await axios.post(
          that.jgjAPi + 'iemanage/azd/screen/getIeDeviceCount',
          {}
        )
        console.log(res)

        that.ieTotalNum = res.data.data.deviceCount
        that.onlineNum = res.data.data.onlineCount
      } catch (err) {
        console.error('加载 getIedevice 出错:', err)
      }
    },
    // ✅ 智能终端 近十天平均分
    async getIeScore() {
      let that = this
      try {
        const response = await axios.get(
          that.jgjAPi + 'iemanage/azd/screen/driversScore',
          {
            params: {
              pageNum: 1,
              pageSize: 10
            }
          }
        )
        console.log(response)
        if (
          response.data.data.records &&
          response.data.data.records.length > 0
        ) {
          let arr = response.data.data.records
          that.iescoreLabels = arr.map((item) => {
            let time = item.createTime.split(' ')[0] || ''
            return time
          })

          let iescoreSeries = [
            {
              name: '安全评分',
              type: 'line',
              data: arr.map((item) =>
                parseFloat(item.onlineRate.replace('%', ''))
              )
            }
          ]
          that.iescoreSeries = iescoreSeries
        }
      } catch (err) {
        console.error('加载 getIedevice 出错:', err)
      }
    },

    // // 工作超过10小时统计
    // getWorktimeoutFn() {
    //   worktimeout(this.queryWorkParams).then((res) => {
    //     if (res.code == 200) {
    //       this.worktimeoutList = res.data
    //     }
    //   })
    // },

    // /** 项目评分 */
    // projectRating() {
    //   let params = {
    //     pageNum: 1,
    //     pageSize: -1,
    //     type: '1',
    //     beginTime: this.beginTime,
    //     endTime: this.endTime
    //   }

    //   return new Promise((resolve) => {
    //     listScore(params).then((response) => {
    //       this.projectRatingData = response.data.records.map((item) => {
    //         return {
    //           label: item.name,
    //           value: item.aveScore
    //         }
    //       })
    //       console.log(this.projectRatingData, '项目评分')
    //     })

    //     resolve()
    //   })
    // },

    // /** 劳务队评分 */
    // workerRating() {
    //   let params = {
    //     projectId: null,
    //     deviceId: null,
    //     pageNum: 1,
    //     pageSize: -1,
    //     type: '2',
    //     beginTime: this.beginTime,
    //     endTime: this.endTime
    //   }

    //   return new Promise((resolve) => {
    //     listScore(params).then((response) => {
    //       this.workerRatingData = response.data.records.map((item) => {
    //         return {
    //           label: item.name || '',
    //           value: item.aveScore
    //         }
    //       })
    //       console.log(response.data.records, '劳务队评分')
    //     })

    //     resolve()
    //   })
    // },

    // /** 查询打卡记录列表 */
    // async getClockList() {
    //   if (this.requestStatus) {
    //     // 利用 return 终止函数继续运行
    //     return false
    //   }
    //   console.log('按钮点击函数执行')
    //   // 执行函数
    //   this.requestStatus = true
    //   setTimeout(() => {
    //     // 模拟执行完毕
    //     // 改变 requestStatus
    //     this.requestStatus = false
    //   }, 1000)
    //   let proInfo = await getProject(this.clockProId)
    //   console.log(proInfo)
    //   if (proInfo && proInfo.data) this.clockProName = proInfo.data.projectName
    //   this.loading = true
    //   this.clockList = []
    //   listClock(this.queryClockParams)
    //     .then((response) => {
    //       this.clockList = response.data
    //       this.total = response.total

    //       this.loading = false
    //       this.clockOpen = true
    //     })
    //     .catch(() => {
    //       this.clockList = []
    //       this.total = 0
    //       this.loading = false
    //     })
    // },
    resize() {},
    /** 图表去详情 */
    toInfo(el) {
      if (el == 'jgj') {
        //(智能终端设备)
        window.open('https://dm.jsjxtzjc.com/', '_blank')
      } else if (el == 'check') {
        //(检测仪表盘)
        this.jump('/detection')
      } else if (el == 'inspect') {
        //(检测仪表盘)
        this.jump('/inspect')
      }
    },
    // 自定义字典展示
    getOptionsType(e, options) {
      if (options && options.length > 0) {
        for (var i = 0; i < options.length; i++) {
          if (options[i].dictValue == e) {
            return options[i].dictLabel
          }
        }
      }
    },
    clockClose() {
      this.clockOpen = false
    },

    //选择日期事件
    handleDateChange(dialogPickerDate, type) {
      if (type == 'clock') {
        if (dialogPickerDate == null) {
          this.pickerDate = []
          this.queryParams.params = {}
        }
        if (dialogPickerDate && dialogPickerDate.length > 0) {
          this.queryParams.params = {}
          this.queryParams.params.beginTime = this.pickerDate[0]
          this.queryParams.params.endTime = this.pickerDate[1]
        }
        this.getClockExceptionFn()
      } else if (type == 'worktime') {
        this.queryWorkParams.pageNum = 1
        this.queryWorkParams.pageSize = 20
        if (dialogPickerDate == null) {
          this.workPickerDate = []
          this.queryWorkParams.params = {}
        }
        if (dialogPickerDate && dialogPickerDate.length > 0) {
          this.queryWorkParams.params = {}
          this.queryWorkParams.params.beginTime = this.workPickerDate[0]
          this.queryWorkParams.params.endTime = this.workPickerDate[1]
        }
        this.getWorktimeoutFn()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* .left-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
} */
/* ✅ 表头样式 */
.table-header {
  display: flex;
  // background: #e6f0fa; /* 浅蓝灰背景 */
  color: #333;
  margin: 10px 0;
  padding: 0 20px;
  font-size: 16px;
  align-items: center;
  justify-content: center;
  // color: #000;
  font-weight: bold;
  // border: 2px solid;
  background: linear-gradient(
    to right,
    rgba(85, 144, 217, 0.4),
    rgba(85, 144, 217, 0.05)
  );
  position: relative;
  // border-image-slice: 1;
  // transition: all 0.4s ease;
  // background: #005eb8;

  border-radius: 16px 16px 0 0;
  height: 32px;
}
/* ✅ 通用列样式 */
.col {
  // padding: 0 8px;
  overflow: hidden;
  display: flex;
  width: 25%;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  text-overflow: ellipsis;
}
.table-list {
  display: flex;
  border-radius: 10px;

  flex-direction: column;
  border: 1px solid #ccc;
}
.table-title {
  display: flex;
  background: rgba(85, 144, 217, 0.1); /* 浅蓝灰背景 */
  padding: 0 20px;
  font-size: 16px;
  align-items: center;
  justify-content: space-around;

  height: 32px;
}
.num-group {
  display: flex;
}
.num-item {
  display: flex;
  width: 50%;
}

.num-box {
  display: flex;
  flex-direction: column;
}
.num-count {
  cursor: pointer;
  font-size: 1.2rem;
  font-weight: 600;
}
.num-count:hover {
  transform: translateY(-2px);
  color: #005eb8;
}
.num-title {
  font-size: 0.8rem;
  color: #333;
}
.driverName {
  color: #005eb8;
}

/* 中部内容 */
.middle-section {
  flex: 1;
  // padding: 10px 0;
  // margin: 1vh 0;
  width: 100%;

  overflow: hidden;
}
.panel-box {
  display: flex;
  justify-content: space-between;
}
.panel-title {
  font-size: 14px;
  font-weight: bold;
  color: #005eb8;
  margin-bottom: 10px;
}
.toInfo {
  // color: #409eff;
  color: #999;
  position: absolute;
  right: 0;
  font-size: 12px;
}
.toInfo:hover {
  cursor: pointer;
}
.driver-list {
  list-style: none;
  padding-left: 0;
  font-size: 14px;
  color: #333;
}

/* 底部信息 */
.bottom-section {
  padding: 10px;
}
.summary-list {
  list-style: none;
  padding-left: 0;
  font-size: 14px;
  color: #444;
  line-height: 1.6;
}
.chart_part {
  // margin-top: 1vh;
  margin-bottom: 1vh;
  .chart {
    // border: #e6e8ec 1px solid;
    // box-sizing: border-box;
    width: 100%;
    height: 18vh;
    background-color: transparent;
    // border-radius: 10px;
    // padding: 0 10px;
    // margin-right: 1%;
  }
}
/* ✅ 滚动区域样式 */
.table-body {
  height: 26vh;
  width: 100%;
  overflow: auto;
  position: relative;
  background-color: transparent;
}
.table-body::-webkit-scrollbar {
  display: none;
}

/* ✅ 表格行 */
.table-row {
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  padding: 8px 0;
  border-bottom: 1px solid #d0dce7;
}
.table-filter {
  width: 100%;
  display: flex;
  ::v-deep .el-range-input {
    background: transparent;
  }
  ::v-deep .el-range-editor.el-input__inner {
    background-color: transparent;
  }
}
// .........../.
/* 弹框样式 */
.modal-overlay {
  position: absolute;
  top: 30vh;
  left: 0;
  width: 600px;
  height: 30vh;

  // background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}
.modal-content {
  background: white;
  border-radius: 15px;
  width: 100%;
  // max-width: 500px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.4s ease;
  position: relative;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-bottom: 10px;
  padding: 10px;
}
.modal-title {
  // font-size: 1rem;
  // color: #2c3e50;
  line-height: 24px;
  font-size: 18px;
  color: #303133;
}
modal-pro {
  padding: 10px;

  line-height: 20px;
  font-size: 16px;
  color: #2c3e50;
}
.modal-body {
  color: #34495e;
  line-height: 1.6;
  margin-bottom: 25px;
}
.container {
  width: 100%;
  // max-width: 1200px;
  // text-align: center;
  display: flex;
  flex-direction: column;
}

.status-cards {
  width: 100%;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 25px;
}

.card {
  // background: rgba(255, 255, 255, 0.95);
  // border-radius: 16px;
  // box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  padding: 10px;
  // width: 300px;
  transition: all 0.3s ease;
  // backdrop-filter: blur(10px);
  // border: 1px solid rgba(255, 255, 255, 0.2);
}

.card:hover {
  transform: translateY(-5px);
  // box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
}

.status-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
}

.online {
  background: linear-gradient(135deg, #00b09b, #96c93d);
  box-shadow: 0 0 10px rgba(0, 176, 155, 0.5);
}

.offline {
  background: linear-gradient(135deg, #8e0e00, #1f1c18);
}

.warning {
  background: linear-gradient(135deg, #ff8c00, #ffcc00);
}
.totalcount {
  background: linear-gradient(135deg, #3498db, #2980b9);
}
.status-title {
  font-weight: 600;
  color: #333;
  // font-size: 1rem;
}

.server-count {
  cursor: pointer;
  font-size: 1rem;
  font-weight: 700;
  color: #2c3e50;
  text-align: center;
}
.server-count:hover {
  color: #005eb8;
}
.server-label {
  color: #7f8c8d;
  font-size: 1rem;
  margin-bottom: 20px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 50px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #3498db, #2980b9);
  color: white;
}

.btn-secondary {
  background: #ecf0f1;
  color: #7f8c8d;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.chart-container {
  height: 100px;
  margin: 20px 0;
}
</style>
